let currentStatus = 'before';
const EventHeader = () => {
    // eslint-disable-next-line no-undef
    const { eventID } = eventVars;
    const wrapper = document.getElementById('event-header');

    if (wrapper.dataset.status) {
        currentStatus = wrapper.dataset.status;
    }

    const getHeader = async () => {
        // eslint-disable-next-line no-undef
        const siteUrl = WPURLS.siteurl;
        const header = await (
            await fetch(
                `${siteUrl}/wp-json/wp/v2/events-header?event_id=${eventID}&skip_cache=1`,
            )
        ).json();
        const { status, content, survey } = header;

        // Status has changed to during so update header
        if (
            content
            && currentStatus
            && currentStatus !== status
            && status === 'during'
        ) {
            wrapper.innerHTML = content;
        }
        if (survey) {
            const event = document.getElementById(`post-${eventID}`);
            event.classList.add('show-survey');
        }

        currentStatus = status;
    };

    getHeader();

    setInterval(() => {
        getHeader();
    }, 10000);
};

export default EventHeader;
